<template>
    <section
        :class="`calendar-layout ${listView === CalendarViewTypeEnum.Map || showFindNearByClientsView || isEmployeeLoading ? 'h-100' : ''}`"
    >
        <CalendarFilters
            v-if="showCalendar || listView === CalendarViewTypeEnum.SummaryView"
            :listView="listView"
            :isEmployeeCalendar="true"
            :startDate="startDate"
            :endDate="endDate"
            :dailyDate="dailyDate"
            :updateDateRange="updateDateRange"
            :dailyDateUpdate="dailyDateUpdate"
            :employeeRefresh="employeeRefresh"
            :handleViewChange="handleViewChange"
            :showMainHeader="showMainHeader"
        />
        <section
            :class="`calendar-content  d-${showCalendar && listView !== CalendarViewTypeEnum.SummaryView ? 'flex' : 'none'} flex-column mb-4`"
        >
            <Pagination
                ref="employeeCalendarPagination"
                entity="employees"
                classes="pagination-footer"
                :pageChanged="pageChanged"
                :isLoading="isEmployeeLoading"
                :pageSize="pageSize"
                v-on:updatePageSizeChanged="updatePageSizeChanged"
                :showPageSizeOptions="false"
            >
                <section class="pagination-main bg-white">
                    <div
                        class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                        v-if="isEmployeeLoading"
                    >
                        <i class="fas fa-calendar-alt fa-7x animate-flash mb-3"></i>
                        <h4>Loading {{ listView }} Calendar...</h4>
                    </div>
                    <template v-if="!hasData || isError">
                        <div
                            class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                            v-if="!hasData && !isEmployeeLoading"
                        >
                            <span class="font-size-3xl"> No Employees Found. </span>
                        </div>
                        <div
                            class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                            v-if="isError"
                        >
                            <p>There was an error while fetching the employee list.<br />Please try again.</p>
                            <button class="btn btn-primary btn-sm" @click="pageReset()">Try Again</button>
                        </div>
                    </template>
                    <EmployeeCalendarContent
                        v-if="listView === CalendarViewTypeEnum.Weekly"
                        class="employee-calendar"
                        :startDate="startDate"
                        :endDate="endDate"
                        :usersList="employees"
                        :tasksList="tasks"
                        :tasksMap="tasksMap"
                        :isPremiumByAgency="isPremiumByAgency"
                        :toggleFindNearByClientsView="toggleFindNearByClientsView"
                        v-on:calendarRefresh="pageReset"
                    />
                    <DailyCalendarContent
                        v-if="listView === CalendarViewTypeEnum.Daily"
                        class="employee-calendar"
                        :startDate="dailyDate"
                        :endDate="dailyDate"
                        :usersList="employees"
                        :tasksList="tasks"
                        :tasksMap="tasksMap"
                        :isPremiumByAgency="isPremiumByAgency"
                        :toggleFindNearByClientsView="toggleFindNearByClientsView"
                        v-on:calendarRefresh="pageReset"
                    />
                </section>
                <template v-if="hasData" #legend>
                    <div class="d-flex flex-wrap ms-auto align-items-center">
                        <div class="d-flex align-items-center me-2">
                            <i class="legend ax-calendar-event legend-success me-1"></i>
                            <span>Completed</span>
                        </div>
                        <div class="d-flex align-items-center me-2">
                            <i class="legend ax-calendar-event legend-danger me-1"></i>
                            <span>Missed</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="legend ax-calendar-event legend-non-visit-bg me-1"></i>
                            <span>Non-Visit Activity</span>
                        </div>
                        <div class="d-flex align-items-center ms-2">
                            <i class="fa fa-home fa-md me-1 cursor pointer"></i>
                            <span>EVV Statuses</span>
                            <a
                                href="javascript:void(0);"
                                role="button"
                                v-custom-popover="{
                                    content: tooltip,
                                    placement: 'top',
                                    className: 'w-10 font-size-sm '
                                }"
                            >
                                <i class="fas fa-info-circle text-primary ms-1"></i>
                            </a>
                        </div>
                    </div>
                </template>
            </Pagination>
        </section>
        <section class="d-flex h-100" v-if="listView === CalendarViewTypeEnum.Map">
            <EmployeeMap :listView="listView" :isEmployeeCalendar="true" :handleViewChange="handleViewChange" />
        </section>
        <section class="d-flex h-100" v-if="listView === CalendarViewTypeEnum.SummaryView">
            <SummaryView :employeeFilterOptions="employeeFilterOptions" />
        </section>
        <section class="h-100" v-if="showFindNearByClientsView">
            <FindNearbyClients
                :toggleFindNearByClientsView="toggleFindNearByClientsView"
                :selectedEmployeeDetails="selectedEmployeeForFindNearbyClient"
            />
        </section>
    </section>
</template>

<script lang="ts" src="./EmployeeCalendar.ts"></script>
